import { useTheme as c, getSafeGutter as a } from "@bedrock-layout/spacing-constants";
import { forwardRefWithAs as p } from "@bedrock-layout/type-utils";
import y from "react";
const m = (t) => ({
  left: "padding-inline-start",
  right: "padding-inline-end",
  top: "padding-block-start",
  bottom: "padding-block-end",
  inlineStart: "padding-inline-start",
  inlineEnd: "padding-inline-end",
  blockStart: "padding-block-start",
  blockEnd: "padding-block-end"
})[t], b = (t, r) => {
  if (Array.isArray(r) && r.length > 4)
    throw new Error("padding arrays can only be 4 or less in length");
  return typeof r == "object" && !Array.isArray(r) ? Object.entries(r).reduce(
    (e, [n, o]) => ({
      ...e,
      [m(n)]: a(t, o) ?? "0px"
    }),
    {}
  ) : {
    padding: Array.from(Array.isArray(r) ? r : [r]).map((e) => a(t, e) ?? "0px").join(" ")
  };
}, f = p(
  ({ as: t, style: r, padding: e, ...n }, o) => {
    const i = c(), d = r ?? {}, s = t ?? "div", l = b(i, e ?? "size00");
    return /* @__PURE__ */ y.createElement(
      s,
      {
        "data-bedrock-padbox": !0,
        ...n,
        ref: o,
        style: { ...d, ...l }
      }
    );
  }
);
f.displayName = "PadBox";
export {
  f as PadBox
};
